import isLocalePresentInUrl from './isLocalePresentInUrl'

export default (url?: string) => {
  if (isLocalePresentInUrl(url)) {
    return url?.substring(3, url.length) ?? '/'
  }

  return url ?? '/'
}
